import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { getFullPath } from 'src/app/lib/get-full-path';
import { RedirectService } from 'src/app/services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class OldModeRedirectGuard  {
  constructor(private redirectService: RedirectService) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const path = getFullPath(next);
    return this.redirectService.redirectTo(
      path.filter(p => p !== 'view' && p !== 'feedback'),
      next.queryParams
    );
  }
}
